if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class NimbiLocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        };

        this.querySelectorAll('button').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }
  );
}
